export enum TeleportationTarget {
  AppTop = '.app-top',
  SubjectRowButtons = '#subject-row-buttons',
}
